module.exports = __webpack_public_path__ + "img/right.7ab4abb1.png";